import { FilterItem, SortItem } from "namirasoft-core";

export class NSBaseMetaTable_Backend<Row>
{
    get?: (id: string) => Promise<Row>;
    list?: (filters: FilterItem[] | null, page: (number | null), size: (number | null), sorts: SortItem[]) => Promise<{ rows: Row[], count: number }>;
};